import type { TranscriptionResponseDTO } from '@klangio/ai2notes-ts-client';
import { createContext } from 'react';
import type { ExportType } from '../../entities';

export interface IExportTranscriptionContextValue {
  isDownloadingExportFile: boolean;
  exportErrorMessage: string | null;
  onDownload: (transcription: TranscriptionResponseDTO, type: ExportType) => void;
  clearError: () => void;
}

export const ExportTranscriptionContextDefaultValue: IExportTranscriptionContextValue = {
  isDownloadingExportFile: false,
  exportErrorMessage: null,
  onDownload: () => {
    throw Error('Missing ExportTranscriptionContext');
  },
  clearError: () => {
    throw Error('Missing ExportTranscriptionContext');
  },
};

const ExportTranscriptionContext = createContext<IExportTranscriptionContextValue>(
  ExportTranscriptionContextDefaultValue,
);

export default ExportTranscriptionContext;
